/**
 * Draw a transparent cutout onto a white canvas.
 * The removal API has no backdrop color; the stored creation stays the PNG cutout.
 * @param {string} imageUrl - blob, data, or same-origin image URL
 * @returns {Promise<string>} blob URL of the flattened PNG
 */
export function compositeCutoutOnWhite(imageUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const width = img.naturalWidth || img.width;
      const height = img.naturalHeight || img.height;
      if (!width || !height) {
        reject(new Error("Could not read cutout size for the white backdrop."));
        return;
      }
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        reject(new Error("Could not flatten cutout onto white."));
        return;
      }
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, width, height);
      ctx.drawImage(img, 0, 0);
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error("Could not flatten cutout onto white."));
          return;
        }
        resolve(URL.createObjectURL(blob));
      }, "image/png");
    };
    img.onerror = () =>
      reject(new Error("Could not load cutout for the white backdrop."));
    img.src = imageUrl;
  });
}
